import { render, staticRenderFns } from "./AppDownFile.vue?vue&type=template&id=5d9bcda3&scoped=true"
import script from "./AppDownFile.vue?vue&type=script&lang=js"
export * from "./AppDownFile.vue?vue&type=script&lang=js"
import style0 from "./AppDownFile.vue?vue&type=style&index=0&id=5d9bcda3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9bcda3",
  null
  
)

export default component.exports